// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"651":"acdf2a3a7851fea3","741":"57d1f9f77c7baac4"}[chunkId] + ".js";
};